
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import BtnRadio from "@/components/scope/btn-radio.vue";
import echarts from "echarts";
import dayjs from "dayjs";
import { Table } from "@common/src/utils/decorator";
import { addCurrencyUnit } from "@common/src/utils/tools";

const finance = namespace("finance");

@Component({
  components: { BtnRadio }
})
@Table("loadServerData")
export default class ReportOutputValue extends Vue {
  @finance.Action queryIncomeExpenseMethodList;
  emptyToLine = emptyToLine;
  splitThousands = splitThousands;
  addCurrencyUnit = addCurrencyUnit;
  formData: any = {
    statisticMethod: "1",
    statisticDate: ""
  };
  myChart: any;
  myChart2: any;
  nowDate: any = dayjs();
  serverData: any = { data: { itemArray: [] } };
  mounted() {
    // 基于准备好的dom，初始化echarts实例
    this.$refs.outputPie && (this.myChart = echarts.init(this.$refs.outputPie));
    this.$refs.outputPie2 && (this.myChart2 = echarts.init(this.$refs.outputPie2));
  }
  created() {
    this.formData.statisticDate = this.nowDate.subtract(1, "d").format("YYYYMMDD");
    this.init();
  }
  init() {
    this.loadServerData();
  }
  draw(serverData?) {
    let nameArr = [];
    let valueArr = [];
    let valueArrExpense = [];
    serverData.data.itemArray &&
      serverData.data.itemArray.forEach(item => {
        nameArr.push(item.incomeExpenseMethodName);
        valueArrExpense.push({
          name: item.incomeExpenseMethodName,
          value: Number(item.expenseAmount)
        });
        valueArr.push({
          name: item.incomeExpenseMethodName,
          value: Number(item.incomeAmount)
        });
      });
    nameArr.push(this.$t("base.ohter"));
    if (serverData.data.other) {
      valueArr.push({
        name: this.$t("base.ohter"),
        value: Number(serverData.data.other.incomeAmount)
      });
      valueArrExpense.push({
        name: this.$t("base.ohter"),
        value: Number(serverData.data.other.expenseAmount)
      });
    }
    let options = {
      tooltip: {
        trigger: "item",
        formatter: params => {
          return `${params.name}<br/>${this.$t("finance.item-output-value")}: ${splitThousands(params.value)}(${
            params.percent
          }%)`;
        }
      },
      legend: {
        show: true,
        icon: "rect",
        bottom: 160,
        width: "100%",
        left: 90,
        itemWidth: 12,
        itemHeight: 12,
        align: "auto",
        itemGap: 30,
        formatter: ["{a|{name}}"].join("\n"),
        textStyle: {
          rich: {
            a: {
              width: 120,
              fontSize: 12,
              lineHeight: 12
            }
          }
        },
        data: nameArr.slice(0, 4)
      },
      color: [
        "#2278F5",
        "#599AFA",
        "#00B478",
        "#5FC71A",
        "#FEBC00",
        "#FF9900",
        "#FE7000",
        "#F74E3B",
        "#E20568",
        "#8543E0",
        "#5D7092"
      ],
      graphic: [
        {
          //环形图中间添加文字
          type: "text", //通过不同top值可以设置上下显示
          left: "17%",
          top: "25%",
          zlevel: 222,
          style: {
            text: addCurrencyUnit(this.$t("finance.receipt-toal"), false, true),
            textAlign: "center",
            fill: "rgba(0, 0, 0, 0.45)",
            width: 200,
            fontSize: 20
          }
        },
        {
          //环形图中间添加文字
          type: "text", //通过不同top值可以设置上下显示
          left: "19%",
          top: "30%",
          zlevel: 223,
          style: {
            text: splitThousands(serverData.data.incomeAmountSum),
            textAlign: "center",
            width: 240,
            height: 30,
            fontSize: 20
          }
        },
        {
          //环形图中间添加文字
          type: "text", //通过不同top值可以设置上下显示
          left: "67%",
          top: "25%",
          zlevel: 223,
          style: {
            text: addCurrencyUnit(this.$t("finance.payment-toal"), false, true),
            textAlign: "center",
            fill: "rgba(0, 0, 0, 0.45)",
            width: 240,
            height: 30,
            fontSize: 20
          }
        },
        {
          //环形图中间添加文字
          type: "text", //通过不同top值可以设置上下显示
          left: "71%",
          top: "30%",
          style: {
            text: splitThousands(serverData.data.expenseAmountSum),
            textAlign: "center",
            width: 240,
            height: 30,
            fontSize: 20
          }
        }
      ],
      series: [
        {
          tooltip: {
            formatter: params => {
              return `${params.name}<br/>${this.$t("finance.income-amount")}: ${splitThousands(params.value)}(${
                params.percent
              }%)`;
            }
          },
          name: this.$t("finance.access-source"),
          type: "pie",
          radius: ["30%", "50%"],
          center: ["25%", "30%"],
          avoidLabelOverlap: false,
          label: {
            show: false
          },
          emphasis: {
            label: {
              show: false,
              fontSize: "30",
              fontWeight: "bold"
            }
          },
          labelLine: {
            show: false
          },
          data: valueArr
        },
        {
          tooltip: {
            formatter: params => {
              return `${params.name}<br/>${this.$t("finance.expense-amount")}: ${splitThousands(params.value)}(${
                params.percent
              }%)`;
            }
          },
          name: this.$t("finance.access-source"),
          type: "pie",
          radius: ["30%", "50%"],
          center: ["75%", "30%"],
          avoidLabelOverlap: true,
          label: {
            show: false
          },
          emphasis: {
            label: {
              show: false,
              fontSize: "30",
              fontWeight: "bold"
            }
          },
          labelLine: {
            show: false
          },
          data: valueArrExpense
        }
      ]
    };
    // 绘制图表
    this.myChart.setOption(options);
  }
  handleDateChange() {
    this.loadServerData("1");
  }
  handleDateTypeChange() {
    if (this.formData.statisticMethod === "1") {
      this.formData.statisticDate = this.nowDate.subtract(1, "d").format("YYYYMMDD");
    } else {
      this.formData.statisticDate = this.nowDate.subtract(1, "M").format("YYYYMM");
    }
    this.loadServerData("1");
  }
  loadServerData(flag = null) {
    this.queryIncomeExpenseMethodList({
      ...this.formData,
      orderItems: this.mix_sortParams
    }).then(data => {
      if (!this.serverData.data.itemArray.length || flag) {
        data.data.itemArray.length && this.draw(data);
      }
      this.serverData = data;
    });
  }
}
